import React from 'react';

const STATUS_STYLES = {
  CONFIRMED: 'bg-emerald-100 text-emerald-800',
  AWAITING_PAYMENT: 'bg-amber-100 text-amber-800',
  PENDING_ALLOCATION: 'bg-slate-100 text-slate-700',
  CANCELLED: 'bg-rose-100 text-rose-800',
  PAYMENT_FAILED: 'bg-rose-100 text-rose-800',
  RELEASED: 'bg-sky-100 text-sky-800',
};

export function bookingStatusBadge(status) {
  const cls = STATUS_STYLES[status] || 'bg-slate-100 text-slate-700';
  return (
    <span className={`text-xs px-2.5 py-1 rounded-full font-bold ${cls}`} data-testid="release-booking-status-badge">
      {status}
    </span>
  );
}
